<template>
  <div id="qr-modal-disable" class="modal fade">
    <div class="modal-dialog">
      <div class="modal-content" style="background: white">
        <div class="modal-header" style="padding: 10px 30px">
          <button type="button" class="close" data-dismiss="modal" ref="close" aria-hidden="true">&times;</button>
          <h3 class="modal-title">Zwei-Faktor-Authentifizierung deaktivieren</h3>
        </div>
        <div class="modal-body">
          <div style="text-align: left">
            <h4>
              Geben Sie Ihren Sicherheitscode
              aus der Authentifizierung-Apps ein, um die Deaktivierung abzuschließen.
            </h4>
            <div class="form-group">
              <input type="text" id="code" class="form-control" v-model="code" placeholder="Sicherheitscode eingeben...">
            </div>
            <div class="alert alert-danger" v-if="errorMsg">
              {{errorMsg}}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" @click="verifyCodeAndDisable">Deaktivieren
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
  name: 'TwoFactorAuthDisableModal',
  data() {
    return {
      code: '',
      errorMsg: ''
    }
  },
  components: {},
  methods: {
    ...mapMutations([
      'setActivated',
    ]),
    verifyCodeAndDisable() {
      axios.post('/backend/profile/2fa/verify-and-toggle', {
        code: this.code,
        action: 'disable'
      }).then(res => {
        let data = res.data;
        if (data.status === 'error') {
          this.errorMsg = 'Der Sicherheitscode ist ungültig.'
        } else {
          this.errorMsg = '';
          this.setActivated(false);
          this.$emit('success', 'disable')
          this.$refs.close.click()
        }
      })
    }
  },
  computed: {
  },
  setup() {
    return {}
  }
}
</script>

<style scoped>
</style>
